var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"folder-tree"},_vm._l((_vm.folders),function(folder){return _c(_setup.MFolderItem,_vm._b({key:folder.id,attrs:{"folder":folder}},'m-folder-item',_vm.$attrs,false))}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }